module.exports = __webpack_public_path__ + "img/mb_hm_block03_04_en.1137a360.png";